import { sessionKeys } from '@/entities/session'
import { redirectToLogin, setUnauthorizedHandler, startMocking } from '@/shared/api'
import { initI18n } from '@/shared/i18n'
import { initObservability } from '@/shared/observability'
import { queryClient } from './query-client'

// Bootstrap до рендера: i18n, observability, MSW (в mock-режиме), и глобальная
// реакция на конец сессии — сброс session + увод на единый вход хаба (клиент
// дёргает этот хендлер, когда 401 пережил продление обоих контуров; shared не
// может импортировать app, поэтому инжектим отсюда).
export async function bootstrap(): Promise<void> {
  await initI18n()
  initObservability()

  // Уходим один раз: 401 прилетает пачкой, а window.location.assign на каждый —
  // гонка навигаций.
  let leaving = false
  setUnauthorizedHandler(() => {
    queryClient.setQueryData(sessionKeys.me, null)
    if (leaving) return
    leaving = true
    redirectToLogin(window.location.href, 'expired')
  })

  await startMocking()
}
